import { Box } from '@mui/material';
import Popover from '@mui/material/Popover';
import { useState } from 'react';

import { FilterProps } from '@common/organisms/CommonFilters/types';
import { ListFilterOption } from '@common/ui/ListFilters/common';
import ListFilterMultiSelect from '@common/ui/ListFilters/ListFilterMultiSelect';
import ListFilterSelectChipTrigger from '@common/ui/ListFilters/ListFilterSelectChipTrigger';
import { useGetSyslogFilterOptions } from '@SystemLog/services/use-system-log-filter-options';
import { formatText } from '@SystemLog/utils/formatText';

export const ACTION_FILTER_LABEL = 'Action';

export default function SystemLogActionFilter({
  opened = false,
  onClose,
  onOpen,
  selected,
  onSelect,
  onClear,
}: FilterProps) {
  const { actions, isLoading } = useGetSyslogFilterOptions();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const options: ListFilterOption[] = actions.map((action) => ({
    value: action,
    label: formatText(action),
  }));

  const selectedOptions = options.filter((option) => selected.includes(option.value));

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    if (onOpen) onOpen();
  };

  const handleClose = () => {
    setAnchorEl(null);
    if (onClose) onClose();
  };

  return (
    <>
      <ListFilterSelectChipTrigger
        active={opened}
        label={ACTION_FILTER_LABEL}
        value={selectedOptions}
        onClear={onClear}
        onClick={handleClick}
        loading={isLoading}
      />
      <Popover
        open={opened}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <Box sx={{ width: 300 }}>
          <ListFilterMultiSelect
            options={options}
            value={selectedOptions}
            onSelect={(values) => onSelect(values.map((v) => v.value))}
            title={`Select ${ACTION_FILTER_LABEL}`}
            isFetching={isLoading}
            enableSearch
          />
        </Box>
      </Popover>
    </>
  );
}
